import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import mnTranslation from './locales/mn.json';
import enTranslation from './locales/en.json';

const resources = {
  mn: {
    translation: mnTranslation
  },
  en: {
    translation: enTranslation
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'mn', // default language
    fallbackLng: 'mn',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
